import { AlertTriangle } from "lucide-react";

// Prominent, non-fine-print disclaimer for any algorithmically generated feasibility/FSI output.
export const IndicativeDisclaimer = ({ className = "" }) => (
  <div
    className={`flex gap-3 p-4 rounded-lg border border-amber-300 bg-amber-50 ${className}`}
    data-testid="indicative-disclaimer"
  >
    <AlertTriangle className="w-5 h-5 text-amber-600 flex-shrink-0 mt-0.5" />
    <div>
      <p className="text-sm font-semibold text-amber-800">Indicative only — not a professional assessment</p>
      <p className="text-xs text-amber-700 mt-1 leading-relaxed">
        These figures (zone, FSI, road width, DP data) are indicative estimates from public GIS/map
        sources that may be outdated. They are <strong>not a substitute for a licensed architect's or
        engineer's assessment</strong>. Always verify with a licensed professional and the relevant
        planning authority before making any decision.
      </p>
    </div>
  </div>
);
